import { AxiosError, HttpStatusCode } from 'axios';

import { ErrorMessage, HttpStatusText } from './http-errors';
import { parseStatus } from './parse-status';

import type { RequestError } from '../request.d';

export async function errorInterceptor(error: AxiosError<any>) {
  const { response } = error;
  const code = response?.status || HttpStatusText[error.code as keyof typeof HttpStatusText];
  const message = response?.data ? response.data?.detail : ErrorMessage[code];
  const isUnauthorized = code === HttpStatusCode.Unauthorized;
  const isTooManyRequests = code === HttpStatusCode.TooManyRequests;

  const failure: RequestError = new Error(parseStatus(code));
  failure.detail = message || ErrorMessage[0];
  failure.response = { ...response, code: error.code } || error;
  failure.status = code;

  if (isUnauthorized && response?.data?.reason) {
    failure.detail = ErrorMessage[code];
  }

  if (isTooManyRequests) {
    failure.detail = ErrorMessage[code];
  }

  throw failure;
}
